import React, { useState } from 'react'
import { Input, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import { CustomCol, CustomTitle } from 'src/components'
import { getTransfersFiltered } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { adminTransfersSelector, setTransferFiltered } from 'src/features'

const TransferListHeader: React.FC<{ quantity: number }> = ({ quantity }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [filterText, setFilterText] = useState(null)
  const { data } = useAppSelector(adminTransfersSelector)

  return <Row>
    {/* Title */}
    <CustomCol lg={16}>
      <CustomTitle label={`${t('general.ResultsLength', { length: quantity })}`} type={null} />
    </CustomCol>

    {/* Text */}
    <CustomCol lg={8}>
      <Input
        allowClear
        value={filterText}
        onChange={(e) => {
          const text = e.target.value
          setFilterText(text)
          const newList = getTransfersFiltered(text, data)
          dispatch(setTransferFiltered(newList))
        }}
        placeholder={t('Withdrawals.Filter')}
        prefix={<SearchOutlined />}
      />
    </CustomCol>
  </Row>
}

export default TransferListHeader
